











import { SanMove } from '../types'

export default {
  computed: {
    moves(): Array<SanMove> {
      return this.$store.state.moves
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./app/javascript/components/move_list.vue